import { getDetailOpportunite } from '@/api/opportunite/index';
import opportuniteInitialize from '@/services/opportunite/opportuniteInitializer';

export default async function getOpportunite(id) {
  const response = await getDetailOpportunite(id);
  opportuniteInitialize(response.data.opportunite);
  return response.data;
}



// WEBPACK FOOTER //
// ./src/services/opportunite/getOpportunite.js